import logoSrc from 'images/login_logo.png';

class LoginController {
  constructor($state, Auth) {
    this.logoSrc = logoSrc;
    this.$state = $state;
    this.Auth = Auth;
  }

  $onInit() {
    this.Auth.getCurrentUser().then(() => this.$state.go('engineer.dashboard'));
  }

  onLogin() {
    this.$state.go('engineer.dashboard');
  }
}

LoginController.$inject = ['$state', 'Auth'];
export default LoginController;



// WEBPACK FOOTER //
// ./src/app/screens/login/login.controller.js